import I18N from '@leverege/i18n';
import DataViewerModel from "../DataViewerModel.js";
import ListDV from "../list/ListDataViewer.js";
import TableDV from "../table/TableDataViewer.js";
import ResponsiveView from "../responsive/ResponsiveView.js";
import ResponsiveModel from "../responsive/ResponsiveModel.js";
import DataViewerModelUpdaterCreator from "../DataViewerModelUpdaterCreator.js";
const {
  tf,
  tfIcon
} = I18N.ns('molten.dataViewers.tableList.TableListDataViewer');
export default {
  id: 'molten.dataViewers.tableList.TableListDataViewer',
  type: 'molten.TableList',
  name: tf('name'),
  icon: tfIcon('configIcon'),
  layout: {
    section: tf('section'),
    sort: 'b.a'
  },
  location: ['main', 'card'],
  matches: {
    type: 'GroupDataViewer'
  },
  component: ResponsiveView,
  settingsUpdaters: DataViewerModelUpdaterCreator.create('ResponsiveViewModelUpdater'),
  createSettings: props => {
    const small = DataViewerModel.create(ListDV.type, ListDV.createSettings(props));
    const large = DataViewerModel.create(TableDV.type, TableDV.createSettings(props));
    const mdl = ResponsiveModel.create({
      dataViewers: [small, large],
      breakpoints: ['minWidth']
    });
    return mdl;
  },
  reset: async props => {},
  getDefaultCardContentOptions: {
    height: '400px'
  }
};